exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control.form-control--stripe{padding-top:.6rem!important}", ""]);

// exports
